import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { initGTM } from './utils/gtm';

// Initialize GTM dynamically, allowing environment override or fallback to the provided ID
initGTM(import.meta.env.VITE_GTM_ID || 'GTM-MCKQPFHS');

/**
 * HashRouter only reads `location.hash`. Recover supported email deep-links
 * when an email client opens them without `#`.
 */
function rewriteNonHashDeepLink() {
  const { pathname, search, hash } = window.location;
  if (hash) return;
  const isTaskLink = pathname.startsWith('/tasks/');
  const isCreatePinLink = pathname === '/create-pin' && new URLSearchParams(search).has('token');
  if (!isTaskLink && !isCreatePinLink) return;
  const target = `/#${pathname}${search}`;
  window.location.replace(target);
}

rewriteNonHashDeepLink();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
